import pathOr from 'ramda/es/pathOr';

import saveDynamicFilterTagStoryHubActions from 'store/actions/saveDynamicFilterTagStoryHubActions';
import { Action } from 'types/Action';
import { SaveDynamicMetaState } from 'types/store/saveDynamicFilter';

const DEFAULT_STATE: SaveDynamicMetaState = {};

const DEFAULT_ACTION: Action<any> = {
  type: '',
  payload: {},
};

export default (state = DEFAULT_STATE, action = DEFAULT_ACTION): any => {
  const localReducer = (): any => {
    return {
      ...state,
      ...action.payload,
    };
  };
  return pathOr(state, [action.type], {
    [saveDynamicFilterTagStoryHubActions.UPDATE]: localReducer(),
    [saveDynamicFilterTagStoryHubActions.CLEAR]: DEFAULT_STATE,
  });
};
